<script>
import imageUrlBuilder from '@sanity/image-url'
import client from '@sanityConfig'
import { colorMixin } from '../../mixins/colorMixin'
import { breakpointsMixin } from '../../mixins/breakpointsMixin'
import { fontMixin } from '../../mixins/fontMixin'
import { mapState } from 'vuex'

const builder = imageUrlBuilder(client)

export default {
  props: {
    component: Object
  },
  mixins: [colorMixin, breakpointsMixin, fontMixin],
  data () {
    return {
    }
  },
  created () {
    this.$_addFont(this.componentFont)
  },
  computed: {
    ...mapState(['settings']),
    componentFont () {
      return (
        this.component && this.component.fontSetup && this.component.fontSetup.font &&
          this.component.fontSetup.font.fontFamily
      )
    },
    partnerImage () {
      if (this.component && this.component.partnerImage) {
        return builder.image(this.component.partnerImage)
      }
      return null
    },
    backgroundImage () {
      if (this.component && this.component.heroImage.desktop) {
        if (this.isMobile && this.component.heroImage.mobile) {
          return builder.image(this.component.heroImage.mobile)
        } else if (this.isTabletOverride && this.component.heroImage.tablet) {
          return builder.image(this.component.heroImage.tablet)
        } else {
          return builder.image(this.component.heroImage.desktop)
        }
      } else {
        console.error('No desktop image defined', this.component.heroImage.desktop)
        return ''
      }
    },
    mobileBackgroundImage () {
      if (this.component && this.component.heroImage.mobile) {
        return builder.image(this.component.heroImage.mobile)
      }
      console.error('No desktop image defined', this.component.heroImage.desktop)
      return ''
    }
  }
}
</script>

<template v-if="component">
  <div
    v-if="settings"
    class="block-one"
    :style="{
      'background-image': `${(isMobile || isTabletOverride)? `url(${mobileBackgroundImage})` : `url(${backgroundImage})`}`,
      '--textColor': $_rgba(component.textColor, 1),
      '--ctaTextColor': $_rgba(component.ctaTextColor, 1),
      '--ctaBGColor': settings.primaryColor.hex,
      '--fontFamily': `'${componentFont && componentFont.family ? componentFont.family : 'Nunito Sans'}'`,
      '--backgroundColor': $_rgba(component.backgroundColor, 1)
    }"
  >
    <div class="content-details">
      <h2
        :style="$_getFontStyle(component, 'heroText')"
        class="title"
        v-if="component.heroText && component.heroText.text && component.heroText.text !== ''"
        >{{component.heroText.text}}
      </h2>
      <h4
        :style="$_getFontStyle(component, 'secondaryHeroText')"
        class="title secondary"
        v-if="component.secondaryHeroText && component.secondaryHeroText.text && component.secondaryHeroText.text !== ''"
        >{{component.secondaryHeroText.text}}
      </h4>
      <p
        :style="$_getFontStyle(component, 'heroCopy')"
        class="hero-copy"
        v-if="component.heroCopy && component.heroCopy.text && component.heroCopy.text !== ''"
        >{{component.heroCopy.text}}
      </p>
      <a
        :style="$_getFontStyle(component, 'ctaText')"
        v-if="
          component.ctaButton &&
          component.ctaButton.isCTA"
        class="button btn-hero"
        :href="component.ctaButton.ctaLink"
      >{{ component.ctaButton.buttonText }}
      </a>
    </div>
    <img :src="partnerImage" alt="partnrer image" v-if="partnerImage" class="hero-image">
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.block-one {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: 100% 0;
  background-color: var(--backgroundColor);
  font-family: var(--fontFamily);
  min-height: 500px;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(auto, 1fr));

  .content-details {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 70px;
    max-width: 500px;

    .title {
      line-height: 82px;
      margin-bottom: 0;
      font-family: $base-font-family;
      font-weight: 800;
      font-size: 84px;
      line-height: 96px;
      color: var(--ctaBGColor);
      text-transform: uppercase;
    }
    .secondary {
      font-size: 48px;
      font-weight: 600;
      line-height: 60px;
    }
    .hero-copy {
      line-height: 30px;
      font-family: $base-font-family;
      font-weight: 600;
      font-size: 16px;
      text-align: left;
      line-height: 130%;
      color: #615334;
    }
    .btn-hero {
      @extend button;
      padding: 1rem 3rem !important;
      color: var(--ctaTextColor);
      background: var(--ctaBGColor);
      font-family: var(--font-family) !important;
      font-weight: var(--font-weight) !important;
      font-size: var(--font-size) !important;
      margin-top: 16px;
    }
  }
  .hero-image {
    max-width: 100%;
  }

}
@media screen and (max-width: 1100px) {
  .block-one {
    min-height: 1000px;
    place-items: start center;
    .content-details {
      .title {
        line-height: 82px;
        font-weight: 800;
        font-size: 48px;
        line-height: 96px;
      }
      .secondary {
        font-size: 24px;
        font-weight: 600;
        line-height: 60px;
      }
      .hero-copy {
        font-size: 14px;
        line-height: 130%;
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .block-one {
    min-height: 600px;
  }
}
</style>
